import 'remixicon/fonts/remixicon.css';
import React from 'react';
import axios from 'axios';
import { TeacherData } from '../../store/viewmodels/TeacherViewModel';
import { useAppSelector } from '../../store/Hooks';
import { Task } from '../../store/viewmodels/TaskViewModel';
import DualTaskItemSetSelection from '../utils/DualTaskItemSetSelection';
import { Student } from '../../store/viewmodels/StudentViewModel';
import { useAppDispatch } from '../../store/Hooks';
import { deleteStudent, modifyStudentInfo, removeStudentFromState } from '../../store/TeacherSlice';


export interface EditKeysModalProps {
    close: () => void,
    student: Student
}

function EditKeysModal(props: EditKeysModalProps) {

    const [name, setName] = React.useState(props.student.identification)
    const [group, setGroup] = React.useState(props.student.group);
    const [tasksIds, setTasksIds] = React.useState<number[]>([]);
    const [itemsetIds, setItemsetIds] = React.useState<number[]>([]);
    const [errorMessage, setErrorMessage] = React.useState("");
    const teacherData: TeacherData = useAppSelector(state => state.teacherData);
    let tasks: Task[] = [];
    if (teacherData.teacher.licences.length > 0) {
        tasks = teacherData.teacher.licences[0].tasks;
    }

    let canDelete: boolean = true; //props.student.results?.length === 0 ? true : false;

    const dispatch = useAppDispatch();
    let options = tasks;

    const handleNameChange = (event: any) => {
        setName(event.target.value);
    }

    const handleGroupChange = (event: any) => {
        setGroup(event.target.value);
    }

    const handleSave = (event: any) => {
        let studentId: number = props.student.id;
        let URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/students/' + studentId + '/' : '/api/students/' + studentId + '/';
        axios.put(URL, {
            username: props.student.username,
            teacher: teacherData.teacher.id,
            group: group,
            task_access_list: tasksIds,
            id: studentId,
            identification: name,
            active_item_sets: itemsetIds
        })
            .then((response) => {
                dispatch(modifyStudentInfo(response.data))
                props.close();
            }, (error) => {
                console.log(error)
                setErrorMessage("Jotain meni pieleen.")
            })
    }

    const handleDelete = async (event: any) => {
        //if (props.student.results?.length !== 0) return;
        let studentId: number = props.student.id
        //let URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/students/' + studentId + '/' : '/api/students/' + studentId + '/'
        dispatch(deleteStudent(studentId))
            .then(() => {
                dispatch(removeStudentFromState(studentId))
            }, (error) => {
                console.log(error)
            }
            )
        // axios.delete(URL)
        //     .then((response) => {
        //         dispatch(removeStudentFromState(studentId))
        //     }, (error) => {
        //         console.log(error)
        //     })
    }

    function getStudentsItemsets(): number[] {
        let itemsetIds = props.student.active_item_sets.map(itemset => itemset.id);
        return itemsetIds;
    }

    const saveButton = (
        <div className="w-1/3 mr-1">
            <button
                onClick={handleSave}
                type="button"
                className="block w-full disabled:opacity-50 border-transparent text-sm font-medium rounded-md text-white border-transparent bg-teal-600 hover:bg-teal-400 focus:shadow-outline text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                Tallenna
            </button>
        </div>);

    const deleteButton = (
        <div className="w-1/3 mr-1 ml-1">
            <button
                onClick={handleDelete}
                type="button"
                className={"block w-full disabled:opacity-50 border-transparent text-sm font-medium rounded-md text-white border-transparent bg-red-600 hover:bg-red-400 focus:shadow-outline text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"}>
                Poista
            </button>
        </div>
    );

    const cancelButton = (
        <div className="w-1/3 ml-1">
            <button
                onClick={props.close}
                type="button"
                className="block w-full border-transparent text-sm font-medium rounded-md text-white border-transparent bg-gray-500 hover:bg-gray-400 focus:shadow-outline text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                Peruuta
            </button>
        </div>
    );

    const buttons = canDelete ?
        <div className="mt-4 w-full flex">
            {saveButton}
            {deleteButton}
            {cancelButton}
        </div>
        :
        <div className="mt-4 w-full flex">
            {saveButton}
            {cancelButton}
        </div>


    return (
        <div className="m-6 w-full">
            <h2 className="mt-6 text-center text-2xl font-extrabold text-gray-900">Muokkaa tietoja</h2>
            <div className="text-red-600">{errorMessage}</div>
            <form className="w-full">
                <div className="items-center mb-4">
                    <label className="text-gray-500 font-bold text-right">Tunnus</label>
                    <input id="studentKey" name="studentKey" type="studentKey" disabled value={props.student.username}
                        className="
                    bg-gray-200 appearance-none border-2 border-gray-200 
                    rounded w-full py-2 px-4 text-gray-700 leading-tight"/>
                    <p className="text-xs">Oppilaan kirjautumistunnus. Tunnusta ei voi muokata.</p>
                </div>
                <div className="items-center mb-4">
                    <label className="text-gray-500 font-bold text-right">Nimi</label>
                    <input id="studentName" placeholder="nimi" value={name} onChange={handleNameChange}
                        className="
                    bg-gray-200 appearance-none border-2 border-gray-200 
                    rounded w-full py-2 px-4 text-gray-700 leading-tight 
                    focus:outline-none focus:bg-white focus:border-teal-500"/>
                </div>
                <div className="items-center mb-4">
                    <label className="text-gray-500 font-bold text-right">Ryhmä</label>
                    <input id="studentGroup" placeholder="ryhmän nimi" value={group} onChange={handleGroupChange}
                        className="
                    bg-gray-200 appearance-none border-2 border-gray-200 
                    rounded w-full py-2 px-4 text-gray-700 leading-tight"/>
                </div>
                <div className="items-center">
                    <div className="mb-4">
                        <label className="text-gray-500 font-bold text-right mb-4">Teemat ja tehtävät</label>
                    </div>
                    <DualTaskItemSetSelection selectableTasks={options} itemset_access_list={getStudentsItemsets()} setItemsetIds={setItemsetIds} setTasksIds={setTasksIds} />
                </div>
                {buttons}
            </form>
        </div>
    );
}

export default EditKeysModal;